import { speed } from "jquery";
import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
export class W3MultiCardSlider {
  swiper: Swiper | null = null;
  swiperElement: HTMLElement | null;
  slides: NodeListOf<HTMLElement> | null;
  slidesContainer: HTMLElement | null;

  constructor() {
    this.slides = document.querySelectorAll(".multicard__slide");
    this.swiperElement = document.querySelector(".multicard__swiper");
    if (this.swiperElement) {
      this.slidesContainer = this.swiperElement?.querySelector(
        ".multicard__wrapper",
      );
    }
    this.initSlider();
  }

  private duplicateSlides(): void {
    if (!this.slidesContainer || !this.slides) return;

    Array.from(this.slides).forEach((slide) => {
      const clone = slide.cloneNode(true) as HTMLElement;
      this.slidesContainer!.appendChild(clone);
    });
  }

  /**
   * Initialize or reinitialize the slider based on the current viewport size and slide count.
   */
  private initSlider(): void {
    var swiper = new Swiper(".multicard__swiper", {
      modules: [Navigation, Pagination],
      slidesPerView: 1,
      spaceBetween: 28,
      loop: true,
      initialSlide: 0,
      speed: 600,
      freeMode: false,
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },

      pagination: {
        el: ".multicard__pagination",
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 1,
      },
      on: {
        slideChange: function (swiper) {
          swiper.slides.forEach((slide) => {
            slide.classList.remove("small-prev", "small-next");
          });
          if (swiper.activeIndex === 0) {
            //set last slide to small-prev
            swiper.slides[swiper.slides.length - 1].classList.add("small-prev");
          } else {
            swiper.slides[swiper.activeIndex - 1].classList.add("small-prev");
          }
          if (swiper.activeIndex >= swiper.slides.length - 3) {
            //set first slide to small-next
            swiper.slides[0].classList.add("small-next");
          } else {
            swiper.slides[swiper.activeIndex + 3].classList.add("small-next");
          }
        },
      },
    });
  }
}
